import { Controller } from "@hotwired/stimulus";
import { clipboardKey, historyKey, selectAllKey } from "../live/history";
import { isEditableElement } from "../utils/is_editable_element.js";

// Connects to data-controller="keyboard-shortcuts" on <body>.
// Global shortcuts, ignored while the user is typing anywhere on the page or
// holding a modifier key (so browser/OS combos like Cmd+/ are left alone), or
// while a modal dialog owns the page (an open live-sheet popup).
// On the Mapas board the board takes the keys it knows first, and undo, redo,
// copy, paste and select all are the modified combinations it gets.
export default class extends Controller {
	static outlets = ["modal", "map-board"];

	handleKeydown(event) {
		if (this.isTyping() || document.querySelector('[role="dialog"][aria-modal="true"]')) return;
		// A control that took the key (a row's grip reordering) keeps it, and so does anything typed in the Combate panel. The path is
		// read from the dispatch, since the handler may have moved the target out of the document by now.
		if (event.defaultPrevented || event.composedPath?.().some((node) => node.matches?.("[data-map-combat-target='panel']"))) return;
		if (event.metaKey || event.ctrlKey || event.altKey) {
			if ((historyKey(event) || clipboardKey(event) || selectAllKey(event)) && this.hasMapBoardOutlet && this.mapBoardOutlet.handleKey(event))
				event.preventDefault();
			return;
		}

		if (this.hasMapBoardOutlet && this.mapBoardOutlet.handleKey(event)) {
			event.preventDefault();
		} else if (event.key === "/") {
			const input = this.searchInputs().find((element) => element.offsetParent !== null);
			if (!input) return;

			event.preventDefault();
			input.focus();
			input.select();
		} else if (event.key === "?") {
			if (!this.hasModalOutlet) return;

			event.preventDefault();
			this.modalOutlet.open();
		}
	}

	searchInputs() {
		return Array.from(document.querySelectorAll('[data-search-autocomplete-target="input"]'));
	}

	// Reuses the same "is the user editing text" check turbo_focus_guard.js
	// uses, plus <select> — no native behavior of ours to protect there, but a
	// shortcut hijacking its own keys (e.g. type-ahead) would still be surprising.
	isTyping() {
		const element = document.activeElement;
		return isEditableElement(element) || element?.tagName === "SELECT";
	}
}
